import Model from "~/models/_Model";

export default class Section extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/eschoolplus/scheduling";
  }

  // Set the resource route of the model
  resource() {
    return "sections";
  }

  primaryKey() {
    return "SECTION_KEY";
  }

  getPrimaryKey() {
    return this[this.primaryKey()];
  }

  relations() {
    return {
      //timesheets: Timesheet,
    };
  }

  // Computed Attributes
  get building_name() {
    switch (this.BUILDING) {
      case "100":
      case 100:
        return "East Leyden High School";
      case "200":
      case 200:
        return "West Leyden High School";
      case "300":
      case 300:
        return "LIFE Program";
      default:
        return this.BUILDING;
    }
  }
}
